import React from 'react'
import { DropDown } from '../../../../../commonComponents/formComponents/dropDown'
import { TranslateContext } from '../../../TranslateContext'
import { useDropdownList } from '../useDropdownList'

const MassUpdateDropdown = (props) => {

    const { fieldName: { key, text, value }, fieldValue, setFieldValue } = props

    const valueList = useDropdownList(key)

    const translate = React.useContext(TranslateContext).translate

    return (
        <DropDown
            id={`${key}`}
            label={translate(`${text}`, { ns: ['default', `${text}`] })}
            className='field-bg dropdown100 addInfoCode'
            labelClass='text-none'
            isLabel={true}
            clearable
            data={valueList}
            disabled={!value?.trim()}
            value={fieldValue}
            onChange={(value) => {
                setFieldValue(value)
            }}

        />
    )
}

export default MassUpdateDropdown